<template>
    <v-dialog
        v-model="dialog"
        max-width="1200"
    >
        <template #activator="{ on, attrs }">
            <v-btn
                color="primary"
                v-bind="attrs"
                v-on="on"
            >
                Banco de imagens
            </v-btn>
        </template>

        <v-card
            height="80vh"
            class="overflow-y-auto"
        >
            <v-card-title>
                Selecione uma imagem do PixiBay
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model="query"
                            outlined
                            hide-details
                            placeholder="Ex: natureza, cidade, etc."
                            :loading="loading"
                        />
                    </v-col>

                    <v-col
                        v-for="(item, index) in items"
                        :key="index"
                        cols="12"
                        md="6"
                        lg="4"
                        xl="3"
                    >
                        <v-card
                            class="ma-2"
                            @click="selectPixiBayImage(item)"
                        >
                            <v-img
                                :src="item.largeImageURL"
                                width="100%"
                                contain
                            />
                        </v-card>
                    </v-col>

                    <v-col
                        v-if="hasMore"
                        cols="12"
                    >
                        <v-btn
                            color="primary"
                            @click="loadMore"
                            block
                        >
                            Carregar mais
                        </v-btn>
                    </v-col>

                    <v-col
                        v-if="items.length === 0"
                        cols="12"
                    >
                        <p class="text-center">
                            Nenhuma imagem encontrada.
                        </p>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { has } from 'lodash'
import debounce from 'lodash/debounce'

export default {
    props: {
        value: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: null
        },
        height: {
            type: Number,
            default: 200
        }
    },
    data() {
        return {
            loading: false,
            dialog: false,
            hasMore: false,
            query: '',
            page: 1,
            items: [],
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
    },
    methods: {
        async search(query) {
            this.items = []
            this.page = 1

            if (!query) {
                return
            }

            this.loading = true

            const response = await this.$api.getImages({
                query
            })

            if (response.error) {
                this.$toast('error', response.message)
                return
            }

            this.items = response.message.hits
            this.page = 1
            this.hasMore = response.message.hits.length > 0

            setTimeout(() => {
                this.loading = false
            }, 800)
        },
        async loadMore(){
            if (!this.query) {
                return
            }

            this.loading = true
            this.page += 1

            const response = await this.$api.getImages({
                query: this.query,
                page: this.page
            })

            if (response.error) {
                this.$toast('error', response.message)
                return
            }

            this.items.push(...response.message.hits)

            this.hasMore = response.message.hits.length > 0
        },
        selectPixiBayImage(item) {
            this.model = item.largeImageURL
            this.dialog = false
            this.query = ''
        }
    },
    watch: {
        query: debounce(function (query) {
            this.search(query)
        }, 500)

    }
}
</script>
